// extracted by mini-css-extract-plugin
module.exports = {"minTabletPortraitWidth":"600px","minTabletLandscapeWidth":"1000px","minDesktopWidth":"1200px","pageFadeOutDuration":".1"};